module.exports = __webpack_public_path__ + "img/pingeneral.8325d525.svg";